import DefaultStore from "./DefaultStore";
import PersonnelSignupStore from "./PersonnelSIgnupStore";

export default {
  defaultStore: new DefaultStore(),
  personnelSignupStore: new PersonnelSignupStore()
};
